var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoom({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_13751)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21132 0.857422H4.19879C1.95818 0.857422 0.142578 2.67302 0.142578 4.9129V8.92543C0.142578 9.83545 0.880072 10.5729 1.79009 10.5737C2.70011 10.5737 3.43761 9.83545 3.43835 8.92543V4.9129C3.43835 4.4938 3.77896 4.15319 4.19805 4.15319H8.21058C9.1206 4.15319 9.8581 3.4157 9.85884 2.50568C9.85884 1.59566 9.1206 0.858162 8.21058 0.857422L8.21132 0.857422ZM25.9104 8.92543V4.9129C25.9104 3.83702 25.4832 2.80556 24.7227 2.04511C23.9623 1.28466 22.9301 0.857422 21.855 0.857422H17.8417C16.9317 0.857422 16.1942 1.59566 16.1942 2.50568C16.1942 3.4157 16.9317 4.15319 17.8417 4.15319H21.855C22.2741 4.15319 22.6139 4.4938 22.6139 4.9129V8.92543C22.6139 9.83545 23.3529 10.5737 24.2622 10.5737C25.1715 10.5737 25.9104 9.83545 25.9104 8.92543ZM17.8417 26.6253H21.855C24.0948 26.6253 25.9104 24.8097 25.9104 22.5698V18.5573C25.9104 17.6473 25.1715 16.909 24.2622 16.909C23.3529 16.909 22.6139 17.6473 22.6139 18.5573V22.5698C22.6139 22.9889 22.2741 23.3288 21.855 23.3295H17.8417C16.9317 23.3295 16.1942 24.067 16.1942 24.977C16.1942 25.887 16.9317 26.6245 17.8417 26.6253ZM0.142578 18.5573V22.5698C0.142578 24.8097 1.95818 26.6253 4.19805 26.6253H8.21058C9.1206 26.6253 9.8581 25.887 9.85884 24.977C9.8581 24.067 9.1206 23.3295 8.21058 23.3295H4.19805C3.99665 23.3295 3.80339 23.2495 3.66122 23.1074C3.51832 22.9645 3.43835 22.7712 3.43835 22.5705V18.558C3.43835 17.648 2.70011 16.9098 1.79009 16.9098C0.880072 16.9098 0.142578 17.648 0.142578 18.558L0.142578 18.5573Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_13751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.7679,
    height: 25.7679,
    fill: "white",
    transform: "translate(0.142578 0.857422)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoom);
export default __webpack_public_path__ + "static/media/zoom.24398addf666704a7f6afdb5e027543d.svg";
export { ForwardRef as ReactComponent };